import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import SmsIntegrationForm from "./SmsIntegrationComponents/SmsIntegrationForm";

import { useAddSmsIntegrationMutation } from "store/services/smsIntegrationApi";

const SmsIntegrationCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "SMS Integrations", path: "/app/crm/sms-integrations/list" },
    { title: "New SMS Integration" },
  ];

  const [addSmsIntegration, { isLoading }] = useAddSmsIntegrationMutation();

  const handleCreateSmsIntegration = async (data) => {
    try {
      const { _id } = await addSmsIntegration(data).unwrap();
      toast.success("SMS Integration successfully created!");
      navigate(`/app/crm/sms-integrations/${_id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create SMS Integration!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <SmsIntegrationForm
          isBusy={isLoading}
          onSubmit={handleCreateSmsIntegration}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default SmsIntegrationCreateScreen;